import { render, staticRenderFns } from "./videorecord.vue?vue&type=template&id=6d09fff4&scoped=true"
import script from "./videorecord.vue?vue&type=script&lang=js"
export * from "./videorecord.vue?vue&type=script&lang=js"
import style0 from "./videorecord.vue?vue&type=style&index=0&id=6d09fff4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09fff4",
  null
  
)

export default component.exports